module.exports = {
	"about": "এর সম্বন্ধে",
	"accepted_invitation_from": "আপনি {invitedBy}  এর আমন্ত্রণ স্বীকার করেছেন এবং {coins} অর্জন করেছেন যোগদানের বোনাস হিসেবে ",
	"accepted_invitation_from_friend": "আপনার বন্ধু {displayName} আপনার আমন্ত্রণ স্বীকার করেছেন! আপনি {coins}  বোনাস স্বরূপ অর্জন করেছেন ",
	"account_disabled": "আপনার একাউন্টটি নিষ্ক্রিয় করা হয়েছে, দয়া করে hello@cricrush.com এ যোগাযোগ করুন ",
	"all_entries": "সকল এন্ট্রিসমূহ",
	"already_registered": "ইতোমধ্যে নিবন্ধনকৃত? ",
	"can_t_find_account": "ও হো, আমার আপনার একাউন্টটি খুঁজে পাইনি। দয়া করে আরেকটি তৈরি করুন!",
	"cant_placed_entries": "আপনি কোন এন্ট্রি বসান নি।",
	"change_profile_picture": "প্রোফাইল ফোটো পরিবর্তন করুন",
	"chat_modal_name": "চ্যাট করুন",
	"claim": "দাবি করুন",
	"click_here_to_resend": "যাচাইকরণ পুনরায় পাঠান",
	"close": "বন্ধ করুন",
	"coming_soon": "শীঘ্রই আসছে",
	"confirm": "নিশ্চিত করুন",
	"countdown_day": "দিন",
	"countdown_days": "দিনসমূহ",
	"countdown_hours": "ঘন্টাসমূহ",
	"countdown_minutes": "মিনিট সমূহ",
	"countdown_seconds": "সেকেন্ডসমূহ",
	"create_account": "একাউন্ট তৈরি করুন",
	"cricrush_league": "ক্রিক্রাশ লিগ",
	"do_not_have_an_account": "আপনার কোন একাউন্ট নেই?",
	"dream_team": "স্বপ্নের দল",
	"dream_team_entry": "স্বপ্নের দলের এন্ট্রি",
	"dream_team_entry_creation_modal_name": "স্বপ্নের দলের এন্ট্রি তৈরি",
	"dream_team_leagues": "স্বপ্নের দলের লিগসমূহ",
	"earn_coins_bonuses": "কয়েন বোনাস আয় করুন",
	"edition": "সংস্করণ",
	"email_not_verified": "ইমেইল পরীক্ষিত নয়",
	"email_not_verified_to_claim_rewards": "পুরস্কার দাবি করতে দয়া করে আপনার ইমেইল যাচাই করুন.",
	"email_title": "Email ইমেইল",
	"enter_valid_email": "সঠিক ইমেইল বসান",
	"entries": "এন্ট্রিসমূহ",
	"entry_created": " - এন্ট্রি তৈরি করা হয়েছে",
	"favourite_teams": "পছন্দের দলসমূহ",
	"fb_reauth": "ফেসবুকের সাথে নিশ্চিত করুন",
	"fb_signin": "ফেসবুক দিয়ে লগইন করুন",
	"fb_signup": "ফেসবুকের মাধ্যমে সাইন আপ করুন",
	"fire_base_already_login_different provider": "আপনি ভিন্ন প্রোভাইডারের সাহায্যে আগে সাইন আপ করেছেন, দয়া করে সঠিক প্রোভাইডার ব্যবহার করে লগইন করুন",
	"fire_base_wrong_message": "কিছু একটা সমস্যা হয়েছে, দয়া করে পরে আবার চেষ্টা করুন!",
	"friend_invite_accepted": "আপনার বন্ধু {friendName}  আপনার আমন্ত্রণ স্বীকার করেছেন  ",
	"ggl_reauth": "গুগলের মাধ্যমে নিশ্চিত করুন",
	"ggl_signin": "গুগলের মাধ্যমে লগইন করুন",
	"ggl_signup": "গুগলের সাথে সাইন আপ করুন",
	"go_back": "পিছনে যান",
	"help": "সাহায্য",
	"invalid_mail": "ভুল ইমেইল অ্যাড্রেস",
	"invitation_accepted": "আমন্ত্রণ স্বীকৃত হয়েছে!",
	"invitation_bonus": "আমন্ত্রণ বোনাস",
	"invite_friends": "বন্ধুদের আমন্ত্রণ জানান",
	"leaderboard": "লিডারবোর্ড",
	"live": "লাইভ",
	"live_prediction": "লাইভ প্রেডিকশন লিগ",
	"live_prediction_entry": "লাইভ প্রেডিকশন লিগ এন্ট্রি",
	"login": "লগইন করুন",
	"login_here": "এখানে লগইন করুন",
	"login_register": "লগইন/ নিবন্ধন করুন",
	"logout": "লগআউট করুন",
	"lost": " - পরাজিত",
	"lost_title": "পরাজিত",
	"no_email_with_account": "এই ইমেইলের সাথে কোন একাউন্ট সংযুক্ত নয়, দয়া করে সাইন আপ করুন",
	"no_network": "কোন নেটওয়ার্ক নেই!",
	"no_network_connection": "কোন নেটওয়ার্ক কানেকশন নেই",
	"notifications": "নোটিফিকেশন সমূহ",
	"or": "অথবা",
	"password_incorrect": "আপনি যে পাসওয়ার্ড দিয়েছেন তা ভুল।",
	"pick_your_country": "আপনার দেশ নির্বাচন করুন",
	"play_button": "খেলুন",
	"predict_score": "ম্যাচের টার্গেট স্কোর অনুমান করুন",
	"profile": "প্রোফাইল",
	"providers_str": "আপনি {providersStr}  পূর্বে ব্যবহার করেছেন। দয়া করে এর মধ্যে কোন একটি ব্যবহার করে লগইন করুন।",
	"providers_str_try_google": "আপনি {providersStr}  ব্যবহার করে পূর্বে লগইন করেছেন। গুগল ব্যবহার করে লগইন করার চেষ্টা করুন।",
	"reauth_modal_title": "কাজটি সম্পন্ন করতে পুনরায় প্রামাণ্যকরণ করুন",
	"received_invitation_bonus": "আমন্ত্রণ বোনাস পেয়েছেন।",
	"refunded": " - “ফেরত দেয়া হয়েছে",
	"refunded_title": "ফেরত দেয়া হয়েছে",
	"register_here": "নিবন্ধন করুন এখানে",
	"save": "সেভ করুন",
	"select_country": "দেশ নির্বাচন করুন এবং কাস্টমাইজড উইনসমূহ উপভোগ করুন!",
	"select_language": "ভাষা নির্বাচন করুন",
	"select_teams": "পছন্দের দলসমূহ",
	"settings": "সেটিংস সমূহ",
	"submit": "জমা দিন",
	"target_prediction": "টার্গেট প্রেডিকশন ",
	"target_prediction_entry": "টার্গেট প্রেডিকশন এন্ট্রি",
	"total": "সর্বমোট",
	"transactions": "ট্রানজ্যাকশনসমূহ",
	"unknown_error": "একটি অজানা সমস্যা ঘটেছে, দয়া করে hello@cricrush.com -এ আমাদের সাথে যোগাযোগ করুন",
	"upcoming": "আসন্ন",
	"user_name": "ইউজার নেম",
	"valid_number": "দয়া করে একটি সঠিক নম্বর বসান!",
	"weak_password": "দুর্বল পাসওয়ার্ড, পাসওয়ার্ডটিকে অবশ্যই ৬ চিহ্নের  বা তার বেশি হতে হবে",
	"won": " - জিতে গেছেন",
	"won_lost_refunded_coins": "আরে, আপনি {earnedCoins}টি কয়েন জিতেছেন এবং {lostCoins} টি কয়েন হারিয়েছেন এবং {refundedCoins} টি কয়েন ফেরত পেয়েছেন। ",
	"won_title": "জিতে গেছেন",
	"you_lost_message": "আপনি হেরে গেছেন",
	"you_won": "আপনি জিতে গেছেন",
	"you_won_reward": "আপনি একটি পুরস্কার জিতেছেন",
	"your_entries": "আপনার  এন্ট্রিসমূহ",
	"your_live_prediction_entry": "আপনার লাইভ প্রেডিকশন এন্ট্রি সমূহ:{prediction} ",
	"your_mom_entry": "আপনার ম্যান অব দ্য ম্যাচের এন্ট্রি:{momEntry} ",
	"your_prediction": "আপনার প্রেডিকশন: {prediction}",
	"display_name": "ডিসপ্লে নাম",
	"email": "ইমেইল",
	"password": "পাসওয়ার্ড",
	"runs_cannot_be_negative_value": "রানসমূহ নেগেটিভ ভ্যালুর হতে পারেনা",
	"budget": "বাজেট $",
	"view_button": " দেখুন",
	"score": "স্কোর: ",
	"rank": "Rank র‌্যাংক: ",
	"target_prediction_leagues": "টার্গেট প্রেডিকশন লিগসমূহ",
	"live_prediction_leagues": "লাইভ প্রেডিকশন লিগসমূহ",
	"target_prediction_description": "ম্যাচের টার্গেট স্কোর প্রেডিক্ট করুন এবং আপনার এন্ট্রি বসান। সঠিক স্কোরের সাথে তুলনা করে আপনার এন্ট্রিসমূহের র‌্যাঙ্ক ঠিক করা হবে।.",
	"required": "প্রয়োজনীয়!",
	"entries_left": " এন্ট্রিসমূহ বাকি আছে",
	"end_of_results": "ফলাফলের সমাপ্তি",
	"invalid_email_address": "ভুল ইমেইল অ্যাড্রেস",
	"completed": "সম্পন্ন হয়েছে",
	"dream_team_description": "আপনার ৪-প্লেয়ার টিম বেছে নিন এবং আপনার এন্ট্রি তৈরি করুন। এবার শান্ত হয়ে বসুন ও আপনার টিম আপনার জন্য স্কোর করতে থাকার সময় খেলা উপভোগ করুন.",
	"reward_claimed_title": "দাবিকৃত পুরস্কার - {reference}",
	"reward_claimed_msg": "রেফারেন্সসহ পুরস্কার দাবির মাধ্যমে কয়েন রিডিম করা হয়েছে- {reference}",
	"update": "আপডেট",
	"processed": "প্রোসেস করা হয়েছে",
	"claim_reward_instructions_title": "দয়া করে নির্দেশনা ভালভাবে পড়ুন!",
	"invalid_filed_instruction": "{field} টি ভুল।দয়া করে চেক করুন!",
	"reward_processed": "পুরস্কার দেয়া হয়েছে!",
	"reward_reference": "আপনার রেফারেন্স: {reference}",
	"claim_coins_message": "এই পুরস্কার দাবি করার মাধ্যমে, আপনার {claimCoins} কয়েনসমূহ কমিয়ে দেয়া হবে।",
	"weekly": "সাপ্তাহিক",
	"daily": "প্রাত্যহিক",
	"monthly": "মাসিক",
	"lifetime": "আজীবন",
	"local": "স্থানীয়",
	"global": "বৈশ্বিক",
	"no_lb_status_generated": "এই লিডার বোর্ডটি জেনারেট করার জন্য আমাদের কাছে যথেষ্ট ডেটা নেই!",
	"you": "আপনি",
	"leaderBoard": "লিডার বোর্ড",
	"mail_sent": "ইমেইল পাঠানো হয়েছে!",
	"verification_mail_sent": "{email} তে একটি ভেরিফিকেশন ইমেইল পাঠানো হয়েছে",
	"messages": "মেসেজসমূহ",
	"country_change_warning": "আপনি বর্তমানের লিডার বোর্ড র‌্যাঙ্ক হারাতে পারেন যদি আপনার দেশ পরিবর্তন করেন.",
	"faq": "ফ্যাক (এফএকিউ)",
	"how_scores_calculated": "স্কোরের হিসাব",
	"how_to_play": "কিভাবে খেলবেন",
	"live_prediction_description": " {teamName} দলের ব্যাটিং ইনিংসের {endOver}তম ওভারের শেষের দিকের স্কোর প্রেডিক্ট করুন। সঠিক স্কোরের সাথে তুলনা করে আপনার এন্ট্রিসমূহের র‌্যাঙ্ক তৈরি করা হবে। ",
	"predict_what_message": " {teamName} দলের ব্যাটিং ইনিংসের {endOver}তম ওভারের শেষের স্কোর প্রেডিক্ট করুন ",
	"pick_team": "আপনার ৪-প্লেয়ার দল বেছে নিন এবং জিতুন",
	"your_entry_created": " আপনার এন্ট্রি তৈরি করা হয়েছে !",
	"fica_title": "এর মাধ্যমে অফিসিয়ালভাবে এন্ডোর্স করা হয়েছে",
	"fica_detailed_text": " ক্রিক্রাশ হল একমাত্র ক্রিকেট অ্যাপ যা ফিকা (এফআইসিএ) এর মাধ্যমে এন্ডোর্স করা হয়েছে",
	"version": "ভার্সন",
	"match_help": "একটি ম্যাচ নির্বাচন করতে এখানে ক্লিক করুন",
	"dream_team_leagues_help": " {matchName} এর জন্য আপনার ৪-প্লেয়ার দল নির্বাচন করতে এখানে ক্লিক করুন",
	"quick_prediction_leagues_help": "{over} তম ওভারের শেষে স্কোর প্রেডিক্ট করতে এখানে ক্লিক করুন ",
	"target_prediction_leagues_help": "{matchName} ম্যাচের টার্গেট স্কোর প্রেডিক্ট করতে এখানে ক্লিক করুন",
	"entries_help": "লাইভ ম্যাচের সময়ের সাথে সাথে আপডেট করা আপনার এন্ট্রি র‌্যাঙ্ক ও স্কোরসমূহ দেখতে এখানে ক্লিক করুন ",
	"more_leaderboard_help": "আপনার লিডার বোর্ড চেক করতে এখানে ক্লিক করুন",
	"more_edition_language_help": "এখানে ক্লিক করুন ও আপনার ভাষা পরিবর্তন করতে এডিশন নির্বাচন করুন",
	"more_edition_country_help": "এখানে ক্লিক করুন ও আপনার দেশ পরিবর্তন করতে এডিশন নির্বাচন করুন",
	"add_coins_help": "কয়েন কি ফুরিয়ে যাচ্ছে? আরো ফ্রি কয়েন এখানে আয় করুন",
	"claimed": "দাবিকৃত",
	"invite_friends_title": "আপনার বন্ধুকে আমন্ত্রণ জানান এবং যখন তারা তাদের প্রথম এন্ট্রি বসাবেন তখন ১০০ কয়েন পান!",
	"daily_claim_bonus_counter_message": "আপনি ইতোমধ্যে আপনার বোনাস দাবি করেছেন!",
	"daily_claim_bonus_message": "আপনার ফ্রি কয়েন এখনই দাবি করুন!",
	"daily_login_bonus": "প্রাত্যহিক লগইন বোনাস",
	"daily_login_bonus_claimed": "প্রাত্যহিক লগইন বোনাস দাবি করা হয়েছে",
	"invite_friends_share_title": "আপনার বন্ধু {name} আপনাকে ক্রিক্রাশে যোগ দিতে আমন্ত্রণ জানিয়েছেন ",
	"invite_friends_share_message": "আপনার বন্ধু {name} ক্রিকাশে যোগদান করার জন্য আপনাকে আমন্ত্রণ জানিয়েছেন। যোগ দিতে, খেলতে এবং চমৎকার সব উপহার পেতে নিচের লিঙ্কে ক্লিক করুন",
	"invite_friends_dialog_title": "যোগ দিতে বন্ধুদের আমন্ত্রণ জানান",
	"live_status": "লাইভ",
	"view_entries": "{noOfEntries} এন্ট্রিসমূহ দেখুন >>",
	"end_of_results2": "আমাদের কাছে এতটাই আছে!",
	"leagues_not_created": "লিগসমূহ শীঘ্রই তৈরি করা হবে...",
	"add_coins": "কয়েন যোগ করুন",
	"expired": "Expired",
	"reward_expired": "Reward Expired!",
	"entries_left2": "{noOfEntries}টি  এন্ট্রিসমূহ বাকি আছে"
};


//////////////////
// WEBPACK FOOTER
// ./src/locales/bn.json
// module id = 485
// module chunks = 0